const FontsConstants = {
  SET_VISIBLE_RANGE: 'FONTS_SET_VISIBLE_RANGE',
  REFRESH: 'FONTS_REFRESH',
  GET: 'FONTS_GET',
  GET_SUCCESS: 'FONTS_GET_SUCCESS',
  GET_FAIL: 'FONTS_GET_FAIL',
  RELOAD: 'FONTS_RELOAD',
  SET_FILTER: 'FONTS_SET_FILTER',
  ACTIVATE_FILTER: 'FONTS_ACTIVATE_FILTER',
  SET_ADVANCED_FILTER: 'FONTS_SET_ADVANCED_FILTER',
  SET_SORTORDER: 'FONTS_SET_SORTORDER',
  MODIFY_SELECTION: 'FONTS_MODIFY_SELECTION',
  ALLOW_MULTI_SELECT: 'FONTS_ALLOW_MULTI_SELECT',
  REMOVE_SUCCESS: 'FONTS_REMOVE_SUCCESS',
  SAVE_SUCCESS: 'FONTS_SAVE_SUCCESS',
  ENSURE_SELECTION_IS_VISIBLE: 'FONTS_ENSURE_SELECTION_IS_VISIBLE',
  CLEAR: 'FONTS_CLEAR',
  UPDATE: 'FONTS_UPDATE',
  SET_SELECTION: 'FONTS_SET_SELECTION',
  OPEN: 'FONTS_OPEN',
  GET_FOR_OPEN_SUCCESS: 'FONTS_GET_FOR_OPEN_SUCCESS',
  GET_BY_ID_SUCCESS: 'FONTS_GET_BY_ID_SUCCESS',
  FIND_SUCCESS: 'FONTS_FIND_SUCCESS',

  UPLOAD_FAIL: 'FONTS_UPLOAD_FAIL',
  REMOVE_FAIL: 'FONTS_REMOVE_FAIL',
  SET_CONFIRM_OVERWRITE: 'FONTS_SET_CONFIRM_OVERWRITE'
};

export default FontsConstants;